export function showHubTeamToast(message, { variant = "info", duration = 6000 } = {}) {
  const existing = document.querySelector(".hub-team-toast")
  if (existing) existing.remove()

  const toast = document.createElement("div")
  toast.className = `hub-team-toast hub-team-toast--${variant}`
  toast.setAttribute("role", "status")
  toast.textContent = message
  document.body.appendChild(toast)

  requestAnimationFrame(() => toast.classList.add("is-visible"))
  window.setTimeout(() => {
    toast.classList.remove("is-visible")
    window.setTimeout(() => toast.remove(), 300)
  }, duration)
}
